import { useContext } from "react";
import { CoinContext } from "../context/coinContext";

export const useCoins = () => {
  return useContext(CoinContext);
};